function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.twitter_st0{fill:#1D9BF0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "white_background",
  className: "twitter_st0",
  d: "M459.6,151.6c0.3,4.5,0.3,9,0.3,13.6C459.9,303.9,354.2,464,161,464v-0.1 C103.9,464,48,447.7,0,416.8c8.3,1,16.6,1.5,25,1.5c47.3,0,93.2-15.8,130.5-45.1c-44.9-0.9-84.4-30.2-98.1-72.9 c15.7,3,32,2.4,47.4-1.8c-49-9.9-84.3-53-84.3-103c0-0.5,0-0.9,0-1.3c14.6,8.1,31,12.6,47.7,13.1C22,176.6,7.8,115.2,35.7,67.1 c53.3,65.6,132,105.5,216.5,109.7c-8.5-36.5,3.1-74.7,30.4-100.4c42.3-39.8,108.8-37.7,148.6,4.6c23.5-4.6,46.1-13.3,66.7-25.5 c-7.8,24.3-24.3,45-46.2,58.1c20.8-2.5,41.2-8,60.3-16.5C497.9,118.3,480.1,136.7,459.6,151.6z"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.187c0b7b.svg";
export { ForwardRef as ReactComponent };